import React from 'react';

import StyledContainer from './styled';

import 'react-toastify/dist/ReactToastify.css';

const AUTO_CLOSE_DELAY = 3000;

const NotificationsContainer = () => (
    <StyledContainer
        position="top-right"
        autoClose={AUTO_CLOSE_DELAY}
        hideProgressBar
        closeOnClick
        draggable
        closeButton={false}
    />
);

export default NotificationsContainer;
